<div class="wrapper-customers-carts">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Customers & Carts" | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-tabs">
    <div
      class="tab-switcher"
      role="tablist"
      [attr.aria-label]="'Customers & Carts' | translate"
    >
      <button
        type="button"
        role="tab"
        class="tab-item"
        [class.active]="activeTab === 'customers'"
        [attr.aria-selected]="activeTab === 'customers'"
        (click)="selectTab('customers')"
      >
        <i class="fi fi-rr-users-alt tab-icon"></i>
        <span class="tab-label">{{ "Customers" | translate }}</span>
      </button>
      <button
        type="button"
        role="tab"
        class="tab-item"
        [class.active]="activeTab === 'abandoned-carts'"
        [attr.aria-selected]="activeTab === 'abandoned-carts'"
        (click)="selectTab('abandoned-carts')"
      >
        <i class="fi fi-rr-shopping-cart tab-icon"></i>
        <span class="tab-label">{{ "Abandoned Carts" | translate }}</span>
      </button>
    </div>
  </div>

  <div class="tab-content">
    <app-customers
      *ngIf="activeTab === 'customers'"
      [embedded]="true"
    ></app-customers>
    <app-abandoned-carts
      *ngIf="activeTab === 'abandoned-carts'"
      [embedded]="true"
    ></app-abandoned-carts>
  </div>
</div>
